import { UserTeamRole } from '../../teams-sdk/teamsSdk';

const userBiTeamRoles = {
  [UserTeamRole.Admin]: 'TeamOwner',
  [UserTeamRole.User]: 'TeamMember',
  [UserTeamRole.Guest]: 'TeamGuest',
  Unknown: 'Unknown'
};

export const getUserInfoTeamRole = (userTeamRole?: UserTeamRole) => {
  return userBiTeamRoles[userTeamRole ?? 'Unknown'];
};
